import throttle from 'lodash/throttle';
import { AUTO_UNAVAILABLE, AVAILABLE, MANUAL_UNAVAILABLE } from '../constants/expertAvailability';
import { showError } from 'util/errorPopupUtil';
import makeCloudFunctionRequest from 'api/makeCloudFunctionRequest';
import { getLoggedInExpert } from '../api/expert';

const ACTIVITY_EVENT_THROTTLE_WAIT = 30 * 1000; // 30 seconds
const ACTIVITY_STATUS_INTERVAL = 5 * 1000; // 5 seconds

const userEvents = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'];
let gatherActivityInterval;

// TODO move code to top level component instead of being detached

// props is passed as reference because values could change
export const initializeListener = async (instance) => {
  // throttle server requests
  const sendActivityEvent = throttle(
    (availability) => {
      // optimistically make available
      makeCloudFunctionRequest('activityEvent').catch((err) => {
        // revert optimistic UI update to original
        instance.props.updateOwnAvailability(availability);
        showError(err);
      });
    },
    ACTIVITY_EVENT_THROTTLE_WAIT,
    {
      leading: true, // only invoke once at start
      trailing: false,
    }
  );

  const getActivityStatus = async () => {
    try {
      const { availabilityStatus } = await getLoggedInExpert();
      if (availabilityStatus !== instance.props.availability) {
        instance.props.updateOwnAvailability(availabilityStatus);
      }
    } catch (error) {
      console.error('Unable to gather current expert activity');
    }
  };

  // make unavailable to give experts time to get ready
  instance.props.updateOwnAvailability(MANUAL_UNAVAILABLE);

  // gather BE activity status through interval
  gatherActivityInterval = setInterval(() => {
    getActivityStatus();
  }, ACTIVITY_STATUS_INTERVAL);

  // throttle events for CPU performance
  const onUserInput = throttle(
    () => {
      if (instance.props.availability === AUTO_UNAVAILABLE) {
        instance.props.updateOwnAvailability(AVAILABLE);
      }
      sendActivityEvent(instance.props.availability);
    },
    100,
    {
      leading: true,
      trailing: false,
    }
  );
  userEvents.forEach((type) => {
    window.document.addEventListener(type, onUserInput);
  });

  return onUserInput;
};

export const removeListener = (listener) => {
  userEvents.forEach((type) => {
    window.document.removeEventListener(type, listener);
  });
  clearInterval(gatherActivityInterval);
};
